import { FC } from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import ShowForRole from '../../../security/ShowForRole';
import EnableForProjectState from '../../../security/EnableForProjectState';

type Props = {
  projectId: number;
  children: JSX.Element;
};

type ProjectStatusProps = {
  isProjectDisabled: boolean;
};

const GroupsPermissions: FC<Props> = ({ projectId, children }) => {
  const render = (projectStatus: ProjectStatusProps): JSX.Element => {
    const { isProjectDisabled } = projectStatus;
    return <>{!isProjectDisabled && children}</>;
  };

  return (
    <ShowForRole
      projectId={projectId}
      roles={[
        Constants.USER_ROLES.ENGAGEMENT_LEAD,
        Constants.USER_ROLES.ENGAGEMENT_MANAGER,
        Constants.USER_ROLES.PROJECT_ADMIN,
        Constants.USER_ROLES.APPROVER,
        Constants.USER_ROLES.TEAM_MEMBER,
      ]}
    >
      <EnableForProjectState projectId={projectId}>
        {render}
      </EnableForProjectState>
    </ShowForRole>
  );
};

export default GroupsPermissions;
